module.exports = __webpack_public_path__ + "static/media/wrongIcon.67c71b78.svg";